import * as yup from "yup"
import type { Path } from "../../types"

export function initialValuesPath(path?: Path | undefined) {
  if (path) {
    return path
  }
  return {
    title: "",
    description: "",
    author: undefined,
    theme: undefined,
    order: 0,
    time_of_reading: 0,
    draft: false,
  }
}

export function validationSchemaPath() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    order: yup.number().required("Campo obbligatorio"),
    theme: yup.number().required("Campo obbligatorio"),
  })
}
